import { useQuery } from '@tanstack/react-query';
import { IGetAllComlaints, IGetAllComplaintsBody } from "../../utils/types";
import { apiManager } from "../api-manager";
import { apiClient } from '../api-manager-instance';
import { ENDPOINTS } from '../endpoints';

export const getAllComplaints = async (params: IGetAllComplaintsBody) => {
  const res = await apiManager.get<IGetAllComlaints>(
    "/admin/complaint/all",
    params
  );
  return res;
};


export const useGetAllComplaints = (params: IGetAllComplaintsBody) =>
  useQuery({
    queryKey: ["get_all_complaints", params],
    queryFn: async (): Promise<IGetAllComlaints> => {
      const res = await apiClient.get(ENDPOINTS.HELP_DESK.GET_ALL_COMPLAINTS, { params });
      return res.data;
    },
  });